import { apiClient } from '@/api/client';

export const logoutService = {
  // Call logout API
  logout: async () => {
    try {
      await apiClient.post('/auth/logout');
    } catch (error) {
      console.error('Logout API failed:', error);
    }
  },

  // Auto logout when storage expires
  autoLogout: async () => {
    await logoutService.logout();
    
    // Clear all storage
    localStorage.clear();
    sessionStorage.clear();
    
    // Clear cookies
    document.cookie.split(";").forEach(cookie => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
    
    // Redirect to login
    window.location.href = '/login';
  }
};